export const PrestazioneHelpers = () => {

    const IsUserIncludedInPrestazione = (prestazione, userId) => {
        return prestazione.prestazione_users.filter((x) => x.UserId === userId).length > 0
    }
    const GetPrestPrefix = (tenantTypeId) => {
        let prefixPrest = "";
        if (tenantTypeId === 1) {
            prefixPrest = "COMM";
        } else if (tenantTypeId === 2) {
            prefixPrest = "CONS";
        } else if (tenantTypeId === 3) {
            prefixPrest = "AVV";
        } else if (tenantTypeId === 4) {
            prefixPrest = "NOT";
        }
        return prefixPrest;
    }
    const CountPrestazioneLivelliRischio = (prestazioni ) => {
        let rischioPrest1 = 0; let rischioPrest2 = 0; let rischioPrest3 = 0; let rischioPrest4 = 0;
        for (let i = 0;i < prestazioni.length;i++) {
            const prestazione = prestazioni[i];
            switch (prestazione.base_tipo_prestazione.Rischio) {
                case 1: {
                    rischioPrest1 ++;
                    break;
                }
                case 2: {
                    rischioPrest2 ++;
                    break;
                }
                case 3: {
                    rischioPrest3 ++;
                    break;
                }
                case 4: {
                    rischioPrest4 ++;
                    break;
                }
                default:
                    break;
            }
        }
        return { rischioPrest1, rischioPrest2, rischioPrest3, rischioPrest4 }
    }

    return {
        IsUserIncludedInPrestazione,
        GetPrestPrefix,
        CountPrestazioneLivelliRischio
    }    
}

// Export standalone functions for backward compatibility
export const getPrestPrefix = (tenantTypeId) => {
    let prefixPrest = "";
    if (tenantTypeId === 1) {
        prefixPrest = "COMM";
    } else if (tenantTypeId === 2) {
        prefixPrest = "CONS";
    } else if (tenantTypeId === 3) {
        prefixPrest = "AVV";
    } else if (tenantTypeId === 4) {
        prefixPrest = "NOT";
    }
    return prefixPrest;
}

export default PrestazioneHelpers;